

















































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import api from '~/services/api';
import AddressSection from '~/components/sections/AddressSection.vue';
import InputSection from '~/components/sections/InputSection.vue';
import SkillSection from '~/components/sections/SkillSection.vue';
import ListSection from '~/components/sections/ListSection.vue';
import JobSection from '~/components/sections/JobSection.vue';
import CountrySection from '~/components/sections/CountrySection.vue';
import TaskCard from '~/components/TaskCard.vue';
import SectionComponent from '~/components/Section.vue';
import Lottie from '~/components/Lottie.vue';
import DatePicker from '~/components/DatePicker.vue';
import CommentSection from '~/components/sections/CommentSection.vue';
import AttachmentsSection from '~/components/sections/AttachmentsSection.vue';
import ProSelectorSection from '~/components/sections/ProSelectorSection.vue';
import Toggle from '~/components/Toggle.vue';
import Toggle2 from '~/components/Toggle2.vue';
import Button from '~/components/Button.vue';
import Invoice from '~/components/Invoice.vue';
import DraftItem from '~/components/DraftItem.vue';
import TaskDetailsModal from '~/components/TaskDetailsModal.vue';
import * as animationData from '~/assets/animations/success.json';
import ClientAddressSection from '~/components/sections/ClientAddressSection.vue';

declare module 'vue/types/vue' {
  // 3. Declare augmentation for Vue
  interface Vue {
    $socketio: any;
    $analytics: any;
    sections: any;
    getDefaultCountry: any;
    getCountries: any;
    $loc: any;
  }
}

type FocusedSection =
  | 'skill'
  | 'department'
  | 'label'
  | 'datetime'
  | 'job'
  | 'comment'
  | 'clientPhoneNumber'
  | 'clientFirstName'
  | 'ownerExternalId'
  | 'clientLastName'
  | 'clientAddress'
  | 'destination'
  | 'clientEmail'
  | 'clientInvoiceFirstName'
  | 'clientInvoiceLastName'
  | 'clientInvoiceEmail'
  | 'clientInvoiceAddress'
  | 'attachments'
  | 'country'
  | 'businessName'
  | 'businessCode'
  | 'businessVatCode'
  | 'furnitureJob'
  | 'productPrice';
type SectionValue = { textValue: string };
interface InputSectionValue extends SectionValue {
  value: string;
}
interface AttachmentsSectionValue extends SectionValue {
  files: {
    name: string;
    fullPath: string;
  }[];
}
interface SkillSectionType extends SectionValue {
  skillId: string;
}
interface JobSectionType extends SectionValue {
  jobId?: string;
  estimate: number;
  label?: string;
  comment?: string;
  skillId?: string;
}

export default Vue.extend({
  name: 'Orders',
  components: {
    SectionComponent,
    Button,
    Toggle,
    Toggle2,
    DraftItem,
    TaskCard,
    Lottie,
    Invoice,
  },
  middleware: ['auth'],
  async asyncData(context) {
    const { skills, services, jobs, labels } = await api.getServicesWithSkills(
      context
    );
    const customer = context.store.state?.auth?.customer;
    // console.log(customer);
    let orders = [];
    if (customer?.role !== 'guest') {
      orders = await api.getCompanyOrders(context, { type: 'confirmed' });
    }
    const company = context.store.state?.auth?.company;
    const hourlyRateOrdersDisabled = company?.hourlyRateOrdersDisabled;
    let invoicesRecipient = company?.invoicesRecipient;
    if (customer?.role === 'admin') {
      invoicesRecipient = '';
    }
    const companyLogo = company?.logo;
    const availableSkills = company?.skillsList;
    const availableJobs = company?.jobsList;
    const visibilityConfigType = company?.visibilityConfigType;
    const displayEmployeeIdInput = company?.displayEmployeeIdInput || false;

    let jobConfig = company?.jobConfigList || [];
    let skillConfig = company?.skillConfigList || [];
    // console.log(availableJobs);
    const sortedLabels = Object.keys(labels)
      .map((key) => {
        return labels[key];
      })
      .sort((s1, s2) => {
        return s2.priority - s1.priority;
      })
      .filter((l) => {
        for (let i = 0; i < jobConfig.length; i++) {
          if (jobConfig[i].labelsList.includes(l.id)) {
            return true;
          }
        }
        for (let i = 0; i < skillConfig.length; i++) {
          if (skillConfig[i].labelsList.includes(l.id)) {
            return true;
          }
        }
        return false;
      });
    if (visibilityConfigType === 'label') {
      // console.log(company.jobsWhitelistExists, company.skillsWhitelistExists);
      if (company.jobsWhitelistExists) {
        jobConfig = jobConfig.filter((config: any) => {
          return availableJobs.includes(config.jobId);
        });
        if (!company.skillsWhitelistExists) {
          skillConfig = [];
        }
      }
      if (company.skillsWhitelistExists) {
        skillConfig = skillConfig.filter((config: any) => {
          return availableSkills.includes(config.skillId);
        });
        if (!company.jobsWhitelistExists) {
          jobConfig = [];
        }
      }
    }
    // console.log(jobConfig, skillConfig);
    // const drafts = [];
    // console.log(drafts);
    // console.log('VISIBILITY', company);
    return {
      skills,
      services,
      labels: sortedLabels,
      jobs,
      customer,
      orders,
      licenseType: company.licenseType,
      departments: company?.departmentsList,
      hourlyRateOrdersDisabled,
      invoicesRecipient,
      companyLogo,
      availableSkills,
      availableJobs,
      visibilityConfigType,
      jobConfig,
      skillConfig,
      displayEmployeeIdInput,
      dataProtectionMode: company.dataProtectionMode,
      contactEmailOptional: company?.contactEmailOptional,
      enableDocumentUpload: company?.enableDocumentUpload,
    };
  },
  data() {
    return {
      enableDocumentUpload: false,
      activeLeftTab: 'newOrder' as 'newOrder' | 'drafts' | 'confirm',
      activeRightTab: 'activeOrders' as 'activeOrders' | 'completedOrders',
      orders: [] as any,
      displayEmployeeIdInput: false,
      completedOrders: null as any,
      departments: null as { externalId: string; name: string }[] | null,
      drafts: null as any,
      hourlyRateOrdersDisabled: false,
      datesLoading: false,
      userIsOwner: true,
      countries: this.getCountries(),
      confirmingOrder: false,
      customInvoiceDetails: false,
      savingOrder: false,
      validated: false,
      prosAvailable: null,
      availabilitySlots: [],
      availableSkills: [] as string[],
      availableJobs: [] as string[],
      focusedSection: null as FocusedSection | null,
      details: {},
      skills: {} as any,
      services: {} as any,
      customer: {} as any,
      jobs: {} as any,
      worklog: null as any,
      orderId: null as null | string,
      isOwner: true,
      isBusiness: false,
      socket: null as any,
      jobConfig: [] as any,
      skillConfig: [] as any,
      timer: null as any,
      licenseType: 'string',
      timerInterval: null as any,
      contactEmailOptional: false,
      promoMode: false,
      labels: [] as any,
      dataProtectionMode: '',
      confirmError: '',
      invoicesRecipient: '',
      visibilityConfigType: 'blacklist',
      companyId: this.$store.state?.auth?.company?.id,
      defaultOptions: {
        animationData,
        autoplay: true,
        loop: false,
      },
      sections: {
        prosAvailable: {
          translationId: 'order.pros',
          value: null as SectionValue | null,
        },
        datetime: {
          translationId: 'order.datetime',
          value: null as SectionValue | null,
        },
        skill: {
          translationId: 'order.skill',
          value: null as SkillSectionType | null,
        },
        label: {
          translationId: 'order.skill',
          value: null as SectionValue | null,
        },
        department: {
          translationId: 'order.department',
          value: null as SectionValue | null,
        },
        job: {
          translationId: 'order.job',
          value: null as JobSectionType | null,
        },
        furnitureJob: {
          translationId: 'order.furnitureJob',
          value: null as SectionValue | null,
        },
        country: {
          translationId: 'order.country',
          value: this.getDefaultCountry(),
        },
        comment: {
          translationId: 'order.comment',
          value: null as SectionValue | null,
        },
        attachments: {
          translationId: 'order.attachments',
          value: null as AttachmentsSectionValue | null,
        },
        clientPhoneNumber: {
          translationId: 'order.clientPhoneNumber',
          value: null as InputSectionValue | null,
        },
        clientFirstName: {
          translationId: 'order.clientFirstName',
          value: null as InputSectionValue | null,
        },
        ownerExternalId: {
          translationId:
            this.$store.state?.auth?.company?.id === '5ixm46MkV2pT7iPUCdci'
              ? 'order.ownerExternalId2'
              : 'order.ownerExternalId',
        },
        clientLastName: {
          translationId: 'order.clientLastName',
          value: null as InputSectionValue | null,
        },
        clientEmail: {
          translationId: 'order.clientEmail',
          value: null as InputSectionValue | null,
        },
        clientInvoiceFirstName: {
          translationId: 'order.clientInvoiceFirstName',
          value: null as InputSectionValue | null,
        },
        clientInvoiceLastName: {
          translationId: 'order.clientInvoiceLastName',
          value: null as InputSectionValue | null,
        },
        clientInvoiceEmail: {
          translationId: 'order.clientInvoiceEmail',
          value: null as InputSectionValue | null,
        },
        clientInvoiceAddress: {
          translationId: 'order.clientInvoiceAddress',
          value: null as SectionValue | null,
        },
        clientAddress: {
          translationId: 'order.clientAddress',
          value: null as InputSectionValue | null,
        },
        destination: {
          translationId: 'order.destination',
          value: null as InputSectionValue | null,
        },
        businessName: {
          translationId: 'order.businessName',
          value: null as InputSectionValue | null,
        },
        businessCode: {
          translationId: 'order.businessCode',
          value: null as InputSectionValue | null,
        },
        businessVatCode: {
          translationId: 'order.businessVatCode',
          value: null as InputSectionValue | null,
        },
        amount: {
          translationId: 'order.amount',
          value: null as InputSectionValue | null,
        },
        productPrice: {
          translationId: 'order.productPrice',
          value: null as InputSectionValue | null,
        },
      },
    };
  },
  head(): any {
    return {
      script: [
        {
          src:
            `https://maps.googleapis.com/maps/api/js?key=${this.$config.PLACES_API_KEY}&libraries=places&language=` +
            this.sections.country.value.value.toLowerCase(),
        },
      ],
    };
  },
  created() {
    this.setOwnerContactInfo();
  },
  mounted() {
    if (this.$route.query?.fk) {
      this.$analytics.trackEvent('view_direct_order_page', {
        fk: this.$route.query?.fk,
        src: this.$route.query?.src,
      });
    }
    if (
      this.customer.role === 'guest' &&
      this.visibilityConfigType !== 'label'
    ) {
      const skills = this.getFilteredSkills();
      const keys = Object.keys(skills);
      console.log(skills);
      if (keys.length === 1) {
        this.sections.skill.value = {
          skillId: skills[keys[0]].id,
          textValue: skills[keys[0]].localizedTitle.lt,
        };
        this.sections.skill.disabled = true;
      }
      this.sections.job.value = {
        estimate: 1,
        comment: '',
      };
    } else if (
      this.customer.role === 'guest' &&
      this.visibilityConfigType === 'label'
    ) {
      if (this.labels.length === 1) {
        const label = this.labels[0];
        this.sections.label.value = {
          textValue: this.$loc(label.localizedTitle),
          value: label.id,
        };
        this.sections.label.disabled = true;
      }
      const jobs = this.getJobs2();
      if (jobs.length === 1) {
        const configItem = jobs[0];
        this.sections.job.value = {
          textValue: configItem.label,
          ...configItem.value,
        };
        this.sections.job.disabled = true;
        this.sections.job.hidden = true;
      }
    }
    if (this.invoicesRecipient === 'client') {
      this.clearOwnerContactInfo();
      this.isOwner = false;
      this.userIsOwner = false;
    }
    if (this.customer.role !== 'guest') {
      this.socket = this.$socketio().onMessage(async (message: any) => {
        // console.log('MESSAGE', message);
        if (message.entityType === 'orders') {
          // console.log('REALTIME RECEIVED');
          this.orders = await api.getCompanyOrders(this, { type: 'confirmed' });
        } else if (message.entityType === 'chatrooms') {
          const response = await api.getChatroomMessages(
            this,
            message.entityId
          );
          for (let i = 0; i < this.orders.length; i++) {
            if (
              this.orders[i].adminProChatroom &&
              this.orders[i].adminProChatroom.id === message.entityId
            ) {
              this.orders[i].adminProChatroom = { ...response.chatroom };
            }
          }
        }
      });
      this.timerInterval = setInterval(() => {
        this.timer = +new Date();
      }, 1000);
    }
  },
  beforeDestroy() {
    this.socket?.removeListeners();
    clearInterval(this.timerInterval);
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    // mergeOrders(newOrders: any) {
    //   const oldOrders = [...this.orders];
    //   const mergedOrders = newOrders;
    //   for (let i = 0; i < oldOrders.length; i++) {
    //     let orderFound = false;
    //     for (let j = 0; j < newOrders.length; j++) {
    //       if (newOrders[j].id === oldOrders[i].id) {
    //         orderFound = true;
    //         break;
    //       }
    //     }
    //     if (!orderFound) {
    //       mergedOrders.push(oldOrders[i]);
    //     }
    //   }
    //   this.orders = mergedOrders;
    // },
    async setActiveLeftTab(tab: 'newOrder' | 'drafts' | 'confirm') {
      this.activeLeftTab = tab;
      if (tab === 'drafts') {
        this.drafts = await api.getCompanyOrders(this, { type: 'drafts' });
      } else {
        this.clearForm();
      }
    },
    async setActiveRightTab(tab: 'activeOrders' | 'completedOrders') {
      this.activeRightTab = tab;
      if (tab === 'activeOrders') {
        this.orders = await api.getCompanyOrders(this, { type: 'confirmed' });
      } else if (tab === 'completedOrders') {
        this.completedOrders = await api.getCompanyOrders(this, {
          type: 'completed',
        });
      }
    },
    isProductPriceSectionVisible() {
      return !!this.sections.job.value?.productPricePercentage;
    },
    getJobs2() {
      const values = [...this.jobConfig, ...this.skillConfig];
      const jobs = values
        .filter((value: any) => {
          return value.labelsList.includes(this.sections.label.value?.value);
        })
        .map((configItem: any) => {
          if (configItem.jobId) {
            const job = this.jobs[configItem.jobId];
            configItem.description = job.localizedTitle;
            configItem.skillId = job.skillId;
            configItem.title = configItem.localizedTitle || job.localizedTitle;
            configItem.estimate = job.durationEstimate / 60;
            configItem.productPricePercentage = job.productPricePercentage;
          } else {
            // const skill = this.skills[configItem.skillId].localizedTitle;
            configItem.title = this.skills[configItem.skillId].localizedTitle;
            configItem.estimate = 1;
          }
          return configItem;
        })
        .map((configItem: any) => {
          return {
            label: this.$loc(configItem.title),
            value: {
              jobId: configItem.jobId,
              skillId: configItem.skillId,
              comment: configItem.description
                ? this.$loc(configItem.title)
                : '',
              estimate: configItem.estimate,
              productPricePercentage: configItem.productPricePercentage,
            },
          };
        })
        .sort((s2: any, s1: any) => {
          return s2.label.localeCompare(s1.label);
        });
      // console.log(jobs);
      return jobs;
    },
    getFilteredJobs(): any {
      if (this.customer.role === 'guest') {
        return [];
      }
      const company = this.$store.state?.auth?.company;
      const jobs = { ...this.jobs };
      company.jobConfigList.forEach((job: any) => {
        if (job.state === 'hidden') {
          delete jobs[job.jobId];
        }
      });
      return jobs;
    },
    canSelectPro(): boolean {
      return this.$store.state?.auth?.company?.canSelectPro;
    },
    getFilteredSkills(): any {
      const jobs = this.getFilteredJobs();
      const skills = { ...this.skills };
      const company = this.$store.state?.auth?.company;
      Object.keys(skills).forEach((skillId) => {
        let numJobs = 0;
        Object.values(jobs).forEach((job: any) => {
          if (job.skillId === skillId) {
            numJobs++;
          }
        });
        if (!skills[skillId]?.hourlyRate?.LT?.EUR) {
          delete skills[skillId];
        } else if (!numJobs && company.hourlyRateOrdersDisabled) {
          delete skills[skillId];
        }
        if (this.customer.role === 'guest') {
          if (!this.availableSkills.includes(skillId)) {
            // console.log(this.availableSkills, skillId);
            delete skills[skillId];
          }
        }
      });
      // console.log(skills);
      return skills;
    },
    getFilteredServices(): any {
      const skills = this.getFilteredSkills();
      const services = { ...this.services };
      Object.keys(services).forEach((serviceId) => {
        const serviceSkills = Object.keys(skills).filter((key) => {
          const skill = this.skills[key];
          // TODO: filtering should be done per country, but hard to do now because country selector is below
          return skill.serviceId === serviceId;
        });
        if (!serviceSkills.length) {
          delete services[serviceId];
        }
      });
      return services;
    },
    openTaskDetails(order: { skillId: string }) {
      const skill = this.skills[order.skillId];
      this.$root.$emit(
        'open-dialog',
        {
          component: TaskDetailsModal,
          title: this.$loc(skill.localizedTitle),
          params: {
            order,
            skill,
            dataProtectionMode: this.dataProtectionMode,
          },
        },
        {
          // onClose: this.getBusinessMembers,
        }
      );
    },
    getCountries() {
      return this.$store.state?.auth?.customer?.countries || ['LT'];
    },
    getDefaultCountry(): InputSectionValue | null {
      const country = this.getCountries()[0];
      return {
        textValue: this.$t('country.' + country),
        value: country,
      };
    },
    getDrafts() {
      return this.drafts;
    },
    getActiveOrders() {
      return this.orders.filter((o: any) => {
        if (this.customer.role === 'owner') {
          return true;
        } else {
          return o.ownerId === this.customer.id;
        }
      });
    },
    getCompletedOrders() {
      return this.completedOrders.filter((o: any) => {
        if (!o.completedAt) {
          return false;
        }
        if (+new Date(o.completedAt) + 3600 * 24 * 62 * 1000 < +new Date()) {
          return false;
        }
        if (this.customer.role === 'owner') {
          return true;
        } else {
          return o.ownerId === this.customer.id;
        }
      });
    },
    createNewOrderForSameClient() {
      this.activeLeftTab = 'newOrder';
      this.sections.datetime.value = null;
      this.sections.job.value = null;
      // this.sections.job.value = null;
      this.worklog = null;
      this.confirmError = '';
    },
    clearForm() {
      this.validated = false;
      this.focusSection(null);
      Object.keys(this.sections).forEach((key: any) => {
        this.sections[key].value = null;
      });
      this.sections.country.value = this.getDefaultCountry();
      if (this.invoicesRecipient === 'client') {
        this.userIsOwner = false;
        this.isOwner = false;
        // TODO: for some reason contact info is not cleared
        this.clearOwnerContactInfo();
      } else {
        this.userIsOwner = true;
        this.isOwner = true;
        this.setOwnerContactInfo();
      }
      this.isBusiness = false;
      this.customInvoiceDetails = false;
      this.worklog = null;
    },
    displayDestinationSection() {
      const skillId = this.getSkillId();
      if (skillId && this.skills[skillId].orderDestinationSection) {
        return true;
      }
      return false;
    },
    addressSectionFilledIn() {
      if (this.sections.clientAddress?.value) {
        if (this.displayDestinationSection()) {
          return !!this.sections.destination?.value;
        } else {
          return true;
        }
      }
      return false;
    },
    async deleteDraft(params: any) {
      await api.deleteDraft(this, params.id);
      this.drafts = await api.getCompanyOrders(this, { type: 'drafts' });
    },
    chooseDraft(params: any) {
      this.resetContactDetails();
      const drafts = this.getDrafts();
      for (let i = 0; i < drafts.length; i++) {
        if (drafts[i].orderId === params.id) {
          const draft = drafts[i];
          this.activeLeftTab = 'newOrder';
          for (const key in this.sections) {
            // @ts-ignore
            this.sections[key].value = null;
          }
          this.sections.country.value = {
            textValue: 'Lietuva',
            value: draft.country || 'LT',
          };
          this.sections.skill.value = {
            skillId: draft.skillId,
            textValue: this.$loc(this.skills[draft.skillId].localizedTitle),
          };
          if (draft.jobId) {
            this.sections.job.value = {
              jobId: draft.jobId,
              estimate: this.jobs[draft.jobId].durationEstimate / 60,
              textValue: this.$loc(this.jobs[draft.jobId].localizedTitle),
              label: this.$loc(this.jobs[draft.jobId].localizedTitle),
              comment: '',
            };
          } else {
            this.sections.job.value = {
              estimate: draft.details.estimate.estimatedTime,
              textValue:
                this.$t(
                  ({
                    1: 'order.estimate.hour',
                    2: 'order.estimate.two',
                    4: 'order.estimate.four',
                  } as any)[draft.details.estimate.textValue]
                ) +
                ', ' +
                draft.details.comment.jobDescription,
              comment: draft.details.comment.jobDescription,
            };
          }
          this.sections.clientAddress.value = draft.details?.address || null;
          this.sections.destination.value = draft.details?.destination || null;
          this.sections.comment.value = draft.details?.ownerComment || null;
          if (draft.contact) {
            this.onToggleOwner(false);
            this.sections.clientFirstName.value = {
              value: draft.contact.firstName,
              textValue: draft.contact.firstName,
            };
            this.sections.clientLastName.value = {
              value: draft.contact.lastName,
              textValue: draft.contact.lastName,
            };
            this.sections.clientEmail.value = {
              value: draft.contact.email,
              textValue: draft.contact.email,
            };
            this.sections.clientPhoneNumber.value = {
              value: draft.contact.phoneNumber,
              textValue: draft.contact.phoneNumber,
            };
            // DEPRECIATED
            // if (draft.contactType === 'businessContact') {
            //   this.isBusiness = true;
            //   this.sections.businessName.value = {
            //     value: draft.contact.businessName,
            //     textValue: draft.contact.businessName,
            //   };
            //   this.sections.businessCode.value = {
            //     value: draft.contact.businessCode,
            //     textValue: draft.contact.businessCode,
            //   };
            //   this.sections.businessVatCode.value = {
            //     value: draft.contact.vatCode,
            //     textValue: draft.contact.vatCode,
            //   };
            // }
          } else {
            this.onToggleOwner(true);
          }
          if (draft.clientInvoiceDetails?.firstName) {
            this.customInvoiceDetails = true;
            this.sections.clientInvoiceFirstName.value = {
              value: draft.clientInvoiceDetails.firstName,
              textValue: draft.clientInvoiceDetails.firstName,
            };
            this.sections.clientInvoiceLastName.value = {
              value: draft.clientInvoiceDetails.lastName,
              textValue: draft.clientInvoiceDetails.lastName,
            };
            this.sections.clientInvoiceEmail.value = {
              value: draft.clientInvoiceDetails.email,
              textValue: draft.clientInvoiceDetails.email,
            };
            if (draft.clientInvoiceDetails?.businessName) {
              this.isBusiness = true;
              this.sections.businessName.value = {
                value: draft.clientInvoiceDetails.businessName,
                textValue: draft.clientInvoiceDetails.businessName,
              };
              this.sections.businessCode.value = {
                value: draft.clientInvoiceDetails.businessCode,
                textValue: draft.clientInvoiceDetails.businessCode,
              };
              this.sections.businessVatCode.value = {
                value: draft.clientInvoiceDetails.vatCode,
                textValue: draft.clientInvoiceDetails.vatCode,
              };
            }
          } else {
            this.customInvoiceDetails = false;
            this.isBusiness = false;
          }
          this.worklog = null;
          this.confirmError = '';
          // await this.createOrder();
          return;
        }
      }
    },
    viewOrderDescription(order: any) {
      const skillName = this.$loc(this.skills[order.skillId].localizedTitle);
      let comment = '';
      if (order.jobId) {
        comment = this.$loc(this.jobs[order.jobId].localizedTitle);
      } else if (order.details?.comment) {
        comment = order.details.comment.jobDescription;
      }
      return [skillName, comment].join(' - ');
    },
    chooseOrder() {},
    viewOrder(order: any) {
      const timezone =
        {
          LT: 'Europe/Vilnius',
          PL: 'Europe/Warsaw',
        }[order.country as string] || 'LT';
      // console.log(order);
      return {
        ...order,
        task: {
          ...order.task,
          datetime: {
            ...order.task.datetime,
            dateText: this.$dayjs(order.task.datetime.timestamp)
              .tz(timezone)
              .format('YYYY-MM-DD HH:mm'),
          },
        },
        contact: order.contact || order.client || {},
        skill: this.skills[order.skillId],
      };
    },
    viewDraft(draft: any) {
      // console.log(draft);
      return {
        id: draft.orderId,
        contactPerson: draft.client
          ? [
              draft.client.firstName,
              draft.client.lastName,
              draft.client.phoneNumber,
            ].join(' ')
          : draft.contact &&
            [
              draft.contact.firstName,
              draft.contact.lastName,
              draft.contact.phoneNumber,
            ].join(' '),
        address: draft.details.address.textValue,
        savedAt: this.$dayjs(draft.createdAt).format('MM-DD'),
        service: this.viewOrderDescription(draft),
      };
    },
    setOwnerContactInfo() {
      this.sections.clientFirstName.value = {
        textValue: this.customer.firstName,
        value: this.customer.firstName,
      };
      this.sections.clientLastName.value = {
        textValue: this.customer.lastName,
        value: this.customer.lastName,
      };
      this.sections.clientEmail.value = {
        textValue: this.customer.email,
        value: this.customer.email,
      };
      this.sections.clientPhoneNumber.value = {
        textValue: this.customer.phoneNumber,
        value: this.customer.phoneNumber,
      };
    },
    clearOwnerContactInfo() {
      [
        'clientEmail',
        'clientPhoneNumber',
        'clientLastName',
        'clientFirstName',
        'clientInvoiceFirstName',
        'clientInvoiceLastName',
        'clientInvoiceEmail',
        'clientInvoiceAddress',
        'businessName',
        'businessVatCode',
        'businessCode',
        'ownerExternalId',
        'department',
      ].forEach((key) => {
        // @ts-ignore
        this.sections[key].value = null;
      });
      const country = this.$store.state?.auth?.company?.country;
      this.sections.clientPhoneNumber.value = {
        textValue: country === 'PL' ? '+48' : '+370',
        value: country === 'PL' ? '+48' : '+370',
      };
    },
    async focusSection(key: FocusedSection | null) {
      // console.log('FOCUS SECTION', key);
      if (key) {
        this.focusedSection = key;
        if ((this.$refs?.[key] as any)?.focus) {
          (this.$refs[key] as any).focus();
        }
      } else {
        this.focusedSection = null;
      }
      if (key === 'datetime') {
        await this.loadAvailability();
      }
    },
    onToggleOwner(value: boolean) {
      this.isOwner = value;
      if (value) {
        this.setOwnerContactInfo();
      } else {
        this.clearOwnerContactInfo();
      }
      this.userIsOwner = value;
    },
    isSpecialFurnitureSkillSelected() {
      // console.log(this.sections.job.value?.skillId);
      return (
        this.customer.role === 'guest' &&
        (this.sections.job.value?.skillId === '8v8QQOoXTVlTIJsUqd6z' ||
          this.sections.skill.value?.skillId === '8v8QQOoXTVlTIJsUqd6z')
      );
    },
    getSkillId() {
      return (
        this.sections.job.value?.skillId || this.sections.skill.value?.skillId
      );
    },
    resetContactDetails() {
      this.clearOwnerContactInfo();
      this.setOwnerContactInfo();
      this.isOwner = true;
    },
    isContactInfoValid() {
      // console.log(this.sections.clientEmail.value?.value, this.isOwner);
      if (
        this.displayEmployeeIdInput &&
        !this.sections.ownerExternalId.value?.value
      ) {
        return false;
      }
      if (
        this.displayEmployeeIdInput &&
        this.departments &&
        !this.sections.department.value?.value
      ) {
        return false;
      }
      if (this.isOwner && !this.customInvoiceDetails) {
        return true;
      }
      let businessValid = true;
      if (this.isBusiness) {
        businessValid = !!(
          this.sections.businessName.value?.value &&
          // this.sections.businessVatCode.value?.value &&
          this.sections.businessCode.value?.value
        );
      }
      let clientInvoiceAddressValid = true;
      let customInvoiceDetailsValid = true;
      if (this.customInvoiceDetails) {
        customInvoiceDetailsValid = !!(
          this.sections.clientInvoiceEmail.value?.value &&
          this.sections.clientInvoiceFirstName.value?.value &&
          this.sections.clientInvoiceLastName.value?.value
        );
        if (this.sections.country.value?.value === 'PL') {
          clientInvoiceAddressValid = !!(
            this.sections.clientInvoiceAddress.value?.streetLine1 &&
            this.sections.clientInvoiceAddress.value?.postcode &&
            this.sections.clientInvoiceAddress.value?.city
          );
        }
      }
      return (
        businessValid &&
        customInvoiceDetailsValid &&
        clientInvoiceAddressValid &&
        this.sections.clientPhoneNumber.value?.value &&
        this.sections.clientFirstName.value?.value &&
        this.sections.clientLastName.value?.value &&
        this.sections.clientEmail.value?.value
      );
    },
    getContactDetails() {
      const contact = {
        email: this.sections.clientEmail.value?.value,
        firstName: this.sections.clientFirstName.value?.value,
        lastName: this.sections.clientLastName.value?.value,
        phoneNumber: this.sections.clientPhoneNumber.value?.value,
        // businessCode: this.sections.businessCode.value?.value,
        // businessVatCode: this.sections.businessVatCode.value?.value,
        // businessName: this.sections.businessName.value?.value,
      };
      return contact;
    },
    getInvoiceDetails() {
      const data: any = {};
      if (this.invoicesRecipient === 'client') {
        data.firstName = this.sections.clientFirstName.value?.value;
        data.lastName = this.sections.clientLastName.value?.value;
        data.email = this.sections.clientEmail.value?.value;
        if (this.isBusiness) {
          data.businessName = this.sections.businessName.value?.value;
          data.businessCode = this.sections.businessCode.value?.value;
          data.vatCode = this.sections.businessVatCode.value?.value;
        }
      } else if (this.customInvoiceDetails) {
        data.firstName = this.sections.clientInvoiceFirstName.value?.value;
        data.lastName = this.sections.clientInvoiceLastName.value?.value;
        data.email = this.sections.clientInvoiceEmail.value?.value;
        if (this.isBusiness) {
          data.businessName = this.sections.businessName.value?.value;
          data.businessCode = this.sections.businessCode.value?.value;
          data.vatCode = this.sections.businessVatCode.value?.value;
        }
      } else {
        data.clientId = this.customer.id;
        data.companyId = this.$store.state?.auth?.company?.id;
      }
      if (this.sections.clientInvoiceAddress.value?.postcode) {
        data.address = this.sections.clientInvoiceAddress.value;
      }
      return data;
    },
    async saveOrder() {
      this.savingOrder = true;
      let contact = null;
      if (!this.userIsOwner) {
        this.validated = true;
        if (this.isContactInfoValid()) {
          contact = this.getContactDetails();
        }
      }
      try {
        this.focusSection(null);
        await api.createDraft(this, this.orderId, {
          country: this.sections.country.value!.value,
          contact,
          comment: this.getJobDescription(),
          ownerComment: this.getOwnerComment(),
          invoiceDetails: this.getInvoiceDetails(),
        });
        this.drafts = await api.getCompanyOrders(this, { type: 'drafts' });
        this.setActiveLeftTab('drafts');
      } catch (error) {
        this.confirmError = this.$t(error.message || 'common.errorOccurred');
      }
      this.savingOrder = false;
    },
    async confirmOrder() {
      this.focusSection(null);
      const params: any = {};
      if (!this.userIsOwner) {
        this.validated = true;
        if (this.isContactInfoValid()) {
          const contact = this.getContactDetails();
          params.contact = contact;
        } else {
          return;
        }
      }
      params.invoiceDetails = this.getInvoiceDetails();
      params.comment = this.getJobDescription();
      params.clientComment = this.getClientComment();
      params.taskDescription = this.getTaskDescription();
      params.ownerComment = this.getOwnerComment();
      if (this.sections.prosAvailable.value?.value) {
        params.workerId = this.sections.prosAvailable.value?.value;
      }
      if (this.displayEmployeeIdInput) {
        params.ownerExternalId = this.sections.ownerExternalId.value?.value;
        if (this.departments) {
          params.departmentExternalId = this.sections.department.value?.value;
        }
      }
      if (this.sections.attachments.value) {
        params.attachments = this.sections.attachments.value;
      }
      this.confirmingOrder = true;
      let response;
      try {
        response = await api.confirmBusinessOrder(this, this.orderId, params);
        if (this.customer?.role !== 'guest') {
          this.orders = await api.getCompanyOrders(this, { type: 'confirmed' });
        }
        this.activeLeftTab = 'confirm';
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (error) {
        this.confirmError = this.$t(error.message || 'common.errorOccurred');
      }
      this.confirmingOrder = false;
      if (response?.order) {
        const order = response.order;
        this.$analytics.trackEvent('submit_order', {
          currency: order.worklog?.currency,
          address: this.sections.clientAddress?.value?.textValue,
          revenue: order.worklog?.total / 100,
          skillId: order.skillId,
          jobId: order.jobId,
          orderId: this.orderId,
          country: order.country,
          comment: params.comment,
          companyName: this.$store.state?.auth?.company.name,
          dateTime: this.sections.datetime.value.textValue,
          fk: this.$route.query?.fk,
        });
      }
      // this.confirmDemoOrder();
    },
    getTaskDescription() {
      const jobComment = this.sections.job.value?.comment; // task description for hourly job in blacklist config or job title (can be customized)
      const furnitureComment = this.sections.furnitureJob.value?.textValue;
      return furnitureComment || jobComment || '';
    },
    getOwnerComment() {
      const ownerComment =
        this.customer.role === 'guest'
          ? ''
          : this.sections.comment.value?.textValue;
      return ownerComment;
    },
    getClientComment() {
      const ownerComment =
        this.customer.role === 'guest'
          ? this.sections.comment.value?.textValue
          : '';
      return ownerComment;
    },
    getJobDescription() {
      const jobId = this.sections.job.value?.jobId;
      let jobDescription = this.sections.job.value?.comment;
      if (jobId) {
        jobDescription =
          this.jobs[jobId].localizedTitle[
            this.sections.country.value!.value.toLowerCase()
          ] || '';
      }
      if (this.customer.role === 'guest') {
        if (this.visibilityConfigType === 'label' && this.sections.job.value) {
          jobDescription = [
            this.sections.job.value?.textValue || '',
            this.sections.furnitureJob.value?.textValue || '',
            this.sections.comment.value?.textValue || '',
          ].join(' ');
          return jobDescription;
        }
        jobDescription = [
          this.sections.furnitureJob.value?.textValue || '',
          this.sections.comment.value?.textValue || '',
          jobDescription,
        ].join(' ');
      } else if (
        this.visibilityConfigType === 'label' &&
        this.sections.job.value
      ) {
        jobDescription = this.sections.job.value?.textValue || '';
      }
      return jobDescription;
    },
    async createOrder() {
      // console.log('CREATE ORDER');
      const jobId = this.sections.job.value?.jobId;
      const jobDescription = this.getJobDescription();
      const comment = this.getOwnerComment();
      // console.log(this.sections.amount);
      if (this.sections.clientAddress.value) {
        const payload = {
          promoMode: false,
          orderDetails: {
            skillId:
              this.sections.skill.value?.skillId ||
              this.sections.job.value?.skillId,
            jobId,
            country: this.sections.country.value!.value,
            amount: this.sections.amount.value?.value
              ? Math.round(parseFloat(this.sections.amount.value.value) * 100)
              : undefined,
            details: {
              address: this.sections.clientAddress.value,
              estimate: {
                estimatedTime: this.sections.job.value?.estimate,
                textValue: this.sections.job.value?.estimate + '',
              },
              comment: {
                text: jobDescription,
                textValue: jobDescription,
                jobDescription,
              },
              ownerComment: {
                text: comment,
                textValue: comment,
              },
              datetime: this.sections.datetime.value,
            },
            // priceDetails:
          },
        };
        if (this.displayDestinationSection()) {
          // @ts-ignore
          payload.orderDetails.details.destination = this.sections.destination?.value;
        }
        if (this.isProductPriceSectionVisible()) {
          // @ts-ignore
          payload.orderDetails.details.productPrice = this.sections.productPrice?.value;
          // console.log('PRODUCT PRICE', this.sections.productPrice?.value.value);
        }
        // console.log('DATES', dates);
        try {
          payload.promoMode = this.promoMode;
          const response = await api.createOrder(this, payload);
          this.worklog = response.data.worklog;
          this.orderId = response.id;
          this.validated = false;
        } catch {
          this.sections.datetime.value = null;
        }
      } else {
        this.validated = true;
      }
    },
    openGuide(step: String) {
      this.$router.push((this as any).localePath('/guide/orders?step=' + step));
    },
    async loadAvailability() {
      this.datesLoading = true;
      const datesPayload = {
        location: (this.sections.clientAddress.value as any).location,
        placeId: (this.sections.clientAddress.value as any).place_id,
        skillId:
          this.sections.skill.value?.skillId ||
          this.sections.job.value?.skillId,
        duration: this.sections.job.value?.estimate,
        country: this.sections.country.value!.value,
      };
      let dates = [];
      try {
        const tokenResponse = await api.refreshToken(this);
        await (this as any).$cookies.set(
          'auth',
          { token: tokenResponse.token },
          {
            path: '/',
            maxAge: 60 * 60 * 24 * 7 * 4,
            sameSite: true,
          }
        );
        dates = await api.getAvailableDates(this, datesPayload);
      } catch (e) {
        this.$sentry.captureException(e);
        window.location.reload();
        // throw new Error(e);
      }
      this.availabilitySlots = dates;
      this.datesLoading = false;
    },
    setPromoMode(mode: boolean) {
      this.promoMode = mode;
      this.sections.datetime.value = null;
    },
    setCustomInvoiceDetails(isCustom: boolean) {
      if (isCustom && !this.userIsOwner) {
        this.sections.clientInvoiceEmail.value = {
          value: this.sections.clientEmail.value?.value,
          textValue: this.sections.clientEmail.value?.value,
        };
        this.sections.clientInvoiceFirstName.value = {
          value: this.sections.clientFirstName.value?.value,
          textValue: this.sections.clientFirstName.value?.value,
        };
        this.sections.clientInvoiceLastName.value = {
          value: this.sections.clientLastName.value?.value,
          textValue: this.sections.clientLastName.value?.value,
        };
      }
    },
    async saveSection(sectionKey: FocusedSection, data: any) {
      if (data.sectionKey) {
        sectionKey = data.sectionKey;
      }
      if (sectionKey === 'clientAddress') {
        this.sections.datetime.value = null;
        this.prosAvailable = null;
        this.worklog = null;
      } else if (sectionKey === 'job') {
        this.sections.datetime.value = null;
        this.prosAvailable = null;
        this.worklog = null;
      } else if (sectionKey === 'productPrice') {
        this.sections.datetime.value = null;
        this.prosAvailable = null;
        this.worklog = null;
      } else if (sectionKey === 'skill') {
        this.sections.datetime.value = null;
        this.prosAvailable = null;
        if (this.customer.role !== 'guest') {
          this.sections.job.value = null;
        }
        this.worklog = null;
      } else if (sectionKey === 'country') {
        this.sections.datetime.value = null;
        this.prosAvailable = null;
        this.sections.clientAddress.value = null;
        this.worklog = null;
      } else if (sectionKey === 'label') {
        this.sections.datetime.value = null;
        this.prosAvailable = null;
        this.sections.job.value = null;
        this.worklog = null;
        // console.log(data);
        if (data.value?.skillId) {
          this.sections.job.value = {
            textValue: data.value.textValue,
            skillId: data.value.skillId,
            estimate: 1,
          };
          this.sections.job.hidden = true;
          this.sections[sectionKey].value = data.value;
          this.focusSection('clientAddress');
          return;
        }
      }
      // console.log('SAVE SECTION', sectionKey, data);
      if (data) {
        // console.log('SAVE SECTION', this.focusedSection, data);
        this.sections[sectionKey].value = data.value;
        if (sectionKey === 'datetime' && data?.value) {
          this.createOrder();
          if (this.$store.state?.auth?.company?.canSelectPro) {
            this.prosAvailable = data.value.prosAvailable;
            this.sections.prosAvailable.value = {
              value: data.value.prosAvailable[0].proId,
              textValue: data.value.prosAvailable[0].name,
            };
          }
        }
        if (data.focusNext) {
          const nextSection = this.getNextSection(sectionKey);
          if (nextSection && sectionKey === 'clientAddress') {
            this.focusSection(nextSection);
            await this.loadAvailability();
            return;
          } else if (nextSection) {
            // console.log(this.$refs);
            this.focusSection(nextSection);
            return;
          }
        }
      }
      if (sectionKey !== 'clientInvoiceAddress') {
        this.focusSection(null);
      }
      // console.log('FOCUSED SECTION', this.focusedSection);
    },
    getNextSection(key: FocusedSection): FocusedSection | null {
      const sequence: FocusedSection[] = [];
      if (this.visibilityConfigType === 'label') {
        sequence.push('label');
      } else {
        sequence.push('skill');
      }
      sequence.push('job');
      if (this.isSpecialFurnitureSkillSelected()) {
        sequence.push('furnitureJob');
      }
      if (this.isProductPriceSectionVisible()) {
        sequence.push('productPrice');
      }
      sequence.push('clientAddress');
      if (this.displayDestinationSection()) {
        sequence.push('destination');
      }
      sequence.push('datetime');
      sequence.push('comment');
      if (this.displayEmployeeIdInput) {
        sequence.push('ownerExternalId');
        if (this.departments) {
          sequence.push('department');
        }
      }
      if (!this.userIsOwner) {
        sequence.push('clientFirstName');
        sequence.push('clientLastName');
        sequence.push('clientEmail');
        sequence.push('clientPhoneNumber');
      }
      if (this.customInvoiceDetails) {
        sequence.push('clientInvoiceFirstName');
        sequence.push('clientInvoiceLastName');
        sequence.push('clientInvoiceEmail');
      }
      if (this.isBusiness) {
        sequence.push('businessName');
        sequence.push('businessCode');
        sequence.push('businessVatCode');
      }
      if (sequence.includes(key)) {
        return sequence[sequence.indexOf(key) + 1];
      }
      return null;
    },
    getOrderSection(sectionId: string) {
      // console.log('get order section', section.id);
      const orderSections = {
        ProSelectorSection: {
          icon: require('~/assets/icons/ic_profile.svg'),
          component: ProSelectorSection,
          isDialog: true,
          props: {
            prosAvailable: this.prosAvailable,
          },
        },
        AddressSection: {
          icon: require('~/assets/icons/ic_pin.svg'),
          component: AddressSection,
          isDialog: true,
          props: {
            country: this.sections.country.value!.value,
          },
        },
        CountrySection: {
          icon: null,
          component: CountrySection,
          isDialog: true,
        },
        DestinationSection: {
          icon: require('~/assets/icons/ic_pin.svg'),
          component: AddressSection,
          isDialog: true,
          props: {
            country: this.sections.country.value!.value,
          },
        },
        LabelSection: {
          icon: require('~/assets/icons/ic_tasks.svg'),
          component: ListSection,
          isDialog: true,
          props: {
            searchFrom: 4,
            options: this.labels.map((l: any) => {
              return {
                label: this.$loc(l.localizedTitle),
                value: { value: l.id, skillId: l.skillId },
              };
            }),
          },
        },
        DepartmentSection: {
          icon: require('~/assets/icons/ic_tasks.svg'),
          component: ListSection,
          isDialog: true,
          props: {
            searchFrom: 4,
            options: (this.departments || []).map((department) => {
              return {
                label: department.name,
                value: { value: department.externalId },
              };
            }),
          },
        },
        JobSection2: {
          icon: require('~/assets/icons/ic_about.svg'),
          component: ListSection,
          isDialog: true,
          props: {
            searchFrom: 4,
            options: (() => {
              const jobs = this.getJobs2();
              // if (jobs.length === 1 && !this.sections.job.value) {
              //   this.sections.job.value = {
              //     textValue: jobs[0].label,
              //     ...jobs[0].value,
              //   };
              //   this.focusSection('clientAddress');
              // }
              return jobs;
            })(),
          },
        },
        SkillSection: {
          icon: require('~/assets/icons/ic_tasks.svg'),
          component: SkillSection,
          props: {
            noService: this.customer.role === 'guest',
            jobs: Object.keys(this.getFilteredJobs())
              .map((key) => {
                const job = this.jobs[key];
                return {
                  ...job,
                  estimate: job.durationEstimate / 60,
                  label: job.id + '.title',
                };
              })
              .sort((s2, s1) => {
                return this.$t(s2.id + '.title').localeCompare(
                  this.$t(s1.id + '.title')
                );
              }),
            services: Object.keys(this.getFilteredServices())
              .map((key) => this.services[key])
              .sort((s1, s2) => {
                return s2.sortPriority - s1.sortPriority;
              }),
            skills: Object.keys(this.getFilteredSkills())
              .map((key) => this.skills[key])
              .sort((s1, s2) => {
                return s2.sortPriority - s1.sortPriority;
              }),
          },
          isDialog: true,
        },
        CommentSection: {
          icon: require('~/assets/icons/ic_tasks.svg'),
          component: CommentSection,
        },
        DateTimeSection: {
          icon: require('~/assets/icons/ic_calendar.svg'),
          component: DatePicker,
          props: {
            country: this.sections.country.value!.value,
            expressCallOutFee: this.$store.state?.auth?.company
              ?.expressCallOutFee,
            availabilitySlots: this.availabilitySlots,
            showAmounts: !(
              this.customer.role === 'guest' || this.licenseType === 'saas'
            ),
          },
          isDialog: true,
        },
        ClientPhoneNumberSection: {
          component: InputSection,
          expanded: true,
          // expanded: true,
          icon: require('~/assets/icons/ic_tasks.svg'),
        },
        ClientEmailSection: {
          component: InputSection,
          expanded: true,
          icon: require('~/assets/icons/ic_tasks.svg'),
          props: {
            showToggle: this.contactEmailOptional,
            toggleLabel: this.$t('order.clientEmail.toggle'),
            disabledValue: 'saskaitos@discontract.com',
          },
        },
        ClientLastNameSection: {
          component: InputSection,
          expanded: true,
        },
        OwnerExternalIdSection: {
          icon: require('~/assets/icons/ic_profile.svg'),
          component: InputSection,
          expanded: true,
        },
        ClientFirstNameSection: {
          icon: require('~/assets/icons/ic_tasks.svg'),
          component: InputSection,
          expanded: true,
        },
        ClientInvoiceEmailSection: {
          component: InputSection,
          expanded: true,
          // expanded: true,
          icon: require('~/assets/icons/ic_tasks.svg'),
        },
        ClientInvoiceAddressSection: {
          component: ClientAddressSection,
          expanded: true,
          // expanded: true,
          icon: require('~/assets/icons/ic_pin.svg'),
        },
        ClientInvoiceLastNameSection: {
          component: InputSection,
          expanded: true,
        },
        ClientInvoiceFirstNameSection: {
          icon: require('~/assets/icons/ic_tasks.svg'),
          component: InputSection,
          expanded: true,
        },
        BusinessNameSection: {
          icon: require('~/assets/icons/ic_tasks.svg'),
          component: InputSection,
          expanded: true,
        },
        AmountSection: {
          icon: require('~/assets/icons/ic_tasks.svg'),
          component: InputSection,
          expanded: true,
        },
        AttachmentsSection: {
          icon: require('~/assets/icons/ic_picture.svg'),
          component: AttachmentsSection,
          expanded: true,
        },
        ProductPriceSection: {
          icon: require('~/assets/icons/ic_price.svg'),
          component: InputSection,
          expanded: true,
          props: {
            validator: (value: string) => {
              const val = parseFloat((value || '').trim().replaceAll(',', '.'));
              return { valid: !!val, value: val + '' };
            },
          },
        },
        BusinessCodeSection: {
          icon: require('~/assets/icons/ic_tasks.svg'),
          component: InputSection,
          expanded: true,
        },
        BusinessVatCodeSection: {
          icon: require('~/assets/icons/ic_tasks.svg'),
          component: InputSection,
          hideArrow: true,
          expanded: true,
        },
        FurnitureJobSection: {
          icon: require('~/assets/icons/ic_tasks.svg'),
          component: CommentSection,
        },
      };
      const sectionConfig = (orderSections as any)[sectionId] || {};
      // console.log('SECTION CONFIG', sectionConfig);
      if (sectionId === 'JobSection') {
        const jobs = Object.keys(this.getFilteredJobs())
          .map((key) => {
            const job = this.jobs[key];
            return {
              ...job,
              estimate: job.durationEstimate / 60,
              label: job.id + '.title',
            };
          })
          .sort((s2, s1) => {
            return this.$t(s2.id + '.title').localeCompare(
              this.$t(s1.id + '.title')
            );
          })
          .filter(
            (job) =>
              job.skillId === this.sections.skill.value?.skillId &&
              job.unitPrice
          );
        jobs.push({
          label: 'order.estimate.hour',
          estimate: 1,
        });
        jobs.push({
          label: 'order.estimate.two',
          estimate: 2,
        });
        jobs.push({
          label: 'order.estimate.four',
          estimate: 4,
        });
        return {
          icon: require('~/assets/icons/ic_about.svg'),
          component: JobSection,
          props: {
            jobs,
            hourlyRateOrdersDisabled: this.hourlyRateOrdersDisabled,
          },
          isDialog: true,
        };
      } else {
        return sectionConfig;
      }
    },
  },
});
